import { consumer } from '@tock/coretypes';
import _ from 'lodash';
import getSocialUrl from 'utils/getSocialUrl';

 
/**
 * https://schema.org/sameAs
 * array of other urls that also represent an organization
 */
export function getSameAs(business?: consumer.IBusinessConfig | null): null | string[] {
  if (!business) {
    return null;
  }

  const facebookUrl = getSocialUrl('https://www.facebook.com/', business.facebookUrl);
  const instagramUrl = getSocialUrl('https://www.instagram.com/', business.instagramId);
  const twitterUrl = getSocialUrl('https://www.twitter.com/', business.twitterHandle);

  return _.filter([business.webUrl, facebookUrl, instagramUrl, twitterUrl]);
}
